import { ActionTypes } from '../constants/index';

export const getSession = (payload: any) => ({
  type: ActionTypes.SESSION_LIST_REQUEST,
  payload,
});
